module.exports = __webpack_public_path__ + "media/images/childcare/main_image1-ab0e826dd0a19089a8121dd941b2ab7c.jpg";